import { fetch } from '@dhl/fetch'
import { TimeWindowDtoUtil, type CountryCode, type TimeWindowDto } from '~/model'

const sleep = (msec: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, msec)
  })

export const getTimeWindows = async (
  apiGwHost: string,
  countryCode: CountryCode,
  postalCode: string,
  useEveningTimeWindows: boolean
) => {
  await sleep(500) // delay is used to provide a smooth ui transition
  const timeWindows: TimeWindowDto[] = await fetch<undefined, TimeWindowDto[]>({
    method: 'GET',
    url: `${apiGwHost}/time-windows?countryCode=${countryCode}&postalCode=${postalCode}`,
  })
  return timeWindows.filter(
    (tw) =>
      (useEveningTimeWindows && !TimeWindowDtoUtil.isSaterdayEveningTimeWindow(tw)) ||
      (!useEveningTimeWindows && !TimeWindowDtoUtil.isEveningTimeWindow(tw))
  )
}
